
{
  "actions": {
    "send": "Send",
    "save-draft": "Save as draft"
  }
}
